export declare type AffintiyTiers = 'Affinity Tier 1' | 'Affinity Tier 2' | 'Affinity Tier 0';

export class OrganizationModel {
  public cst_key: string = undefined;
  public cst_recno: number = undefined;
  public cst_phn_number_complete_dn: string = undefined;
  public cxa_mailing_label: number = undefined;
  public org_name: string = undefined;
  public org_affinity_payment_optin_flag_ext: number = undefined;
  public org_affinity_payment_type_ext: 'Monthly' | 'Prepaid' | null = undefined;
  public org_affinity_payment_combo_packages_ext: string = undefined;
  public adr_line1: string = undefined;
  public adr_city: string = undefined;
  public adr_state: string = undefined;
  public adr_post_code: string = undefined;
  public IsInstructorReferral: boolean = undefined;
  public HasStudentPortals: boolean = undefined;
  public DefaultBPP: number = undefined;

  public Tier: {
    'ABMP': AffintiyTiers,
    'ASCP': AffintiyTiers,
    'AHP': AffintiyTiers,
    'ANP': AffintiyTiers
  } = {
    'ABMP': null,
    'ASCP': null,
    'AHP' : null,
    'ANP' : null
  };

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'cst_recno':
              const cst_recno = parseInt(source.cst_recno, 10) || null;
              this.cst_recno = cst_recno;
            break;
            case 'Tier':
              for (const asn in source.Tier) {
                if (source.Tier.hasOwnProperty(asn)) {
                  this.Tier[asn] = source.Tier[asn];
                }
              }
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
